import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { JobsStats, JobsStatsWidgetsAppState } from './types';

const initialState: JobsStatsWidgetsAppState = {};

export const initialStats: JobsStats = {
  active: 0,
  waiting: 0,
  failed: 0,
  total: 0,
};

type JobsStatsPayload = {
  widgetId: string;
  stats: JobsStats;
};

export const jobsStatsWidgetsSlice = createSlice({
  name: 'jobs_stats_widgets',
  initialState,
  reducers: {
    setJobWidgetStats: (state, action: PayloadAction<JobsStatsPayload>) => {
      state[action.payload.widgetId] = action.payload.stats;
    },
  },
});

export const { setJobWidgetStats } = jobsStatsWidgetsSlice.actions;

export const jobsStatsWidgetsReducer = jobsStatsWidgetsSlice.reducer;
